import React from 'react'
import styled from 'styled-components'

export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`

interface propsType {
  children: React.ReactNode
}

const ModalTest: React.FC<propsType> = ({children}) => {
  return (
    <ModalContainer>
      {children}
    </ModalContainer>
  )
}

export default ModalTest